import { StringValue } from '@coveo/bueno';
import { parametersDefinition } from '../parameters/parameters-schema.js';
export const searchParametersDefinition = {
    q: new StringValue(),
    ...parametersDefinition,
};
